<template>
  <div class="auth-callback">
    <div class="auth-callback__box">
      <img
        :src="logoUrl || defaultLogoUrl"
        alt="Logo da garantidora"
        class="auth-callback__logo"
        @error="handleLogoError"
      />
      <h1>Preparando seu ambiente...</h1>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
import authService from '../auth/oidc'

export default {
  name: 'AuthCallbackView',
  data: () => ({
    message: '',
    defaultLogoUrl: '/images/logogarantepay.jpg',
    logoUrl: authService.getActiveGuarantorLogoUrl()
  }),
  async created () {
    try {
      const returnPath = await authService.completeSignInRedirect()
      this.logoUrl = await authService.refreshActiveGuarantorBrand()
      await this.$nextTick()
      this.$router.replace(returnPath)
    } catch (error) {
      this.message = 'Nao foi possivel concluir o acesso. Tente entrar novamente.'
      await authService.clearAuthState()
      setTimeout(() => {
        this.$router.replace({ name: 'login' })
      }, 2500)
    }
  },
  methods: {
    handleLogoError () {
      this.logoUrl = null
      authService.clearActiveGuarantorLogoUrl()
    }
  }
}
</script>

<style scoped>
.auth-callback {
  align-items: center;
  background: #f2f4f7;
  display: flex;
  justify-content: center;
  min-height: 100vh;
}

.auth-callback__box {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  max-width: 360px;
  padding: 32px;
  text-align: center;
  width: 90%;
}

.auth-callback__logo {
  margin-bottom: 20px;
  max-width: 220px;
  width: 100%;
}

.auth-callback h1 {
  color: #1f2937;
  font-size: 20px;
  margin: 0 0 10px;
}

.auth-callback p {
  color: #5f6b7a;
  font-size: 14px;
  margin: 0;
}
</style>
